// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.invoice-row .el-icon-edit[data-v-2f6ec5ca] {\n  color: orange;\n}\n[dir] .invoice-row .el-icon-edit[data-v-2f6ec5ca] {\n  cursor: pointer;\n}\np.invoice-row[data-v-2f6ec5ca] {\n  line-height: 16px;\n}\n[dir] p.invoice-row[data-v-2f6ec5ca] {\n  margin-bottom: 0.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
